import { ECrudType } from 'redux/actions/crud';
import shiftMapper from 'redux/mappers/shift';
import { GetReducer, ICrudState } from './crud';
import moment from 'moment-timezone';
import { DATETIME_FORMAT } from 'utils/date';
import { getDurationDisplay } from 'components/atom/duration-dropdown';

export interface IShiftState extends ICrudState {
  today?: boolean;
}

const reducer = GetReducer(
  ECrudType.shifts,
  shiftMapper,
  (obj: any) => ({
    ...obj,
    dropdown: `${moment.tz(obj.startDate, obj.tz).format(DATETIME_FORMAT)} - ${getDurationDisplay(obj.duration / 60)}`,
  }),
  (state: any, action: any) => {
    switch (action.type) {
      case ECrudType.shifts + '_TODAY':
        return {
          ...state,
          today: action.payload,
        };
    }
  },
);

export default reducer;
